import React, { useEffect } from 'react'

// library
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'
import { connect, useDispatch } from 'react-redux'

// components
import { ContainerFluid, Row, Col } from '@navent-jobs/ui-kit/components/grid'
import { Textarea } from '@navent-jobs/ui-kit/components/textarea'
import ConfirmationModal from '../ConfirmationModal'

// assets
import { FormGroup, LabelInput } from '../../../mixins'
import { CustomSubmitButton } from '../mixins'
import { deleteAccount } from '../../../../../redux/actions/applicant/account/delete'
import { showSnackbar, showSnackbarError } from '../../../../../redux/actions/applicant/curriculum/snackbar'
import { logoutAction } from '../../../../../redux/actions/logout'
import { hideModal, showModal } from '../../../../../redux/actions/modal'

const TIME_AWAIT = 3000

const EliminarCuentaForm = ({ status, statusLogout }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { success, error, loading } = status

  // Inicializamos Hook Form
  const {
    watch,
    formState: { errors },
    formState,
    control,
    reset,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  const motivoField = watch('motivo')

  const onConfirmDelete = () => {
    dispatch(showModal('modal-confirm-delete-account'))
  }

  const onHideConfirmDelete = () => {
    dispatch(hideModal())
  }

  const goHome = () => {
    window.location.href = '/'
  }

  const actionSuccess = () => {
    dispatch(showSnackbar(t('account.deleteAccount.snackbarMessage.success'), 'icon-light-save'))
    reset({ motivo: '' })
    dispatch(logoutAction())
  }

  useEffect(() => {
    if (success) {
      hideModal()
      actionSuccess()
    } else if (error) {
      dispatch(showSnackbarError(t('account.deleteAccount.snackbarMessage.error')))
    }
  }, [status])

  useEffect(() => {
    if (statusLogout.success) {
      setTimeout(() => {
        goHome()
      }, TIME_AWAIT)
    } else if (statusLogout.error) {
      dispatch(showSnackbarError(t('account.deleteAccount.snackbarMessage.error')))
    }
  }, [statusLogout])

  const confirmDeleteAccountHandler = () => {
    // password es null porque no se requiere
    const dataForm = {
      password: null,
      motivo: motivoField,
    }

    if (motivoField) {
      dispatch(deleteAccount({ data: dataForm }))
    }
  }

  return (
    <>
      <form id="form-delete-account">
        <ContainerFluid>
          <Row>
            <Col noGutter lg={12} md={12}>
              <FormGroup>
                <Controller
                  control={control}
                  name="motivo"
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <Textarea
                      id="motivo"
                      name="motivo"
                      value={value}
                      onChange={onChange}
                      disabled={loading}
                      maxLength={1000}
                      fieldOptions={{
                        label: <LabelInput> {t('account.deleteAccount.reason.title')}</LabelInput>,
                        variant: 'darken',
                        allowOnlyText: true,
                      }}
                      placeholder={t('account.deleteAccount.reason.placeholder')}
                      rules={{ required: true }}
                      errors={{ ...errors }}
                    />
                  )}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col noGutter>
              <CustomSubmitButton
                idForm="form-delete-account"
                isLoading={loading}
                disabled={!formState.isValid || loading}
                onClick={e => {
                  e.preventDefault()
                  onConfirmDelete()
                }}
              >
                {t('account.deleteAccount.buttonDelete')}
              </CustomSubmitButton>
            </Col>
          </Row>
        </ContainerFluid>
      </form>

      {/* Modal confirmacion */}
      <ConfirmationModal
        name="modal-confirm-delete-account"
        title={t('account.deleteAccount.confirmModal.title')}
        isLoading={loading}
        cancelHandler={() => onHideConfirmDelete()}
        confirmHandler={() => confirmDeleteAccountHandler()}
      />
    </>
  )
}

const states = ({ deleteAccountStore, logoutStore }) => {
  const { status, invalidPassword } = deleteAccountStore
  return { status, invalidPass: invalidPassword, statusLogout: logoutStore.status }
}

export default connect(states)(EliminarCuentaForm)
